// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getImageUrlWithCacheBuster = (url: string | undefined): string | null => {
  if (!url || !url.startsWith('http')) return null;

  // Sử dụng '&' nếu URL đã có '?', ngược lại dùng '?'
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${new Date().getTime()}`;
};
 